import { isOptionInstrument } from '../../utils/optionInstrument';

export const determineTradeTypes = (tradePlan) => {
  let orderTypes;
  const isOptionTrade = isOptionInstrument(tradePlan.instrument);
  const isOptionLong =
    isOptionTrade && tradePlan.optionManagement.buyOrSellOption === 'LONG';
  const isOptionShort =
    isOptionTrade && tradePlan.optionManagement.buyOrSellOption === 'SHORT';
  if (tradePlan.goLong) {
    if (isOptionTrade) {
      if (isOptionLong) {
        orderTypes = [
          { val: 'BTO', label: 'BTO' },
          { val: 'STC', label: 'STC' },
        ];
      }
      if (isOptionShort) {
        orderTypes = [
          { val: 'STO', label: 'STO' },
          { val: 'BTC', label: 'BTC' },
        ];
      }
    } else {
      orderTypes = [
        { val: 'BTO', label: 'BTO' },
        { val: 'STC', label: 'STC' },
      ];
    }
  }
  if (tradePlan.goShort) {
    if (isOptionTrade) {
      if (isOptionLong) {
        orderTypes = [
          { val: 'BTO', label: 'BTO' },
          { val: 'STC', label: 'STC' },
        ];
      }
      if (isOptionShort) {
        orderTypes = [
          { val: 'STO', label: 'STO' },
          { val: 'BTC', label: 'BTC' },
        ];
      }
    } else {
      orderTypes = [
        { val: 'STO', label: 'STO' },
        { val: 'BTC', label: 'BTC' },
      ];
    }
  }

  return orderTypes;
};
